module.exports = __webpack_public_path__ + "static/media/pembridge.67318f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/pembridge.png
// module id = 137
// module chunks = 0